var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0189 14.2248C19.6677 12.8446 19.9999 11.4361 19.9999 10.0343C19.9999 8.50116 19.6374 7.04428 18.8912 5.57991C18.7678 5.34867 18.5587 5.17508 18.3087 5.0965C18.0586 5.01791 17.7878 5.04061 17.5543 5.1597C17.3209 5.2788 17.1435 5.48478 17.0604 5.73332C16.9773 5.98186 16.9951 6.25309 17.1099 6.48866C17.7093 7.66429 18.0005 8.82429 18.0005 10.0343C18.0005 10.9176 17.831 11.8109 17.4953 12.7013L19.0189 14.2248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0341 17.24C23.2523 15.0585 24 13.0468 24 10.0343C24 6.83932 23.1825 4.79432 21.8644 2.53432C21.7265 2.31512 21.5088 2.15799 21.2574 2.09601C21.0059 2.03403 20.7402 2.07204 20.5162 2.20202C20.2922 2.33201 20.1273 2.54384 20.0563 2.79292C19.9854 3.042 20.0138 3.30891 20.1357 3.53744C21.3163 5.56432 22 7.27682 22 10.0343C22 12.4054 21.4759 14.0212 20.558 15.7638L22.0341 17.24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1716 5.03431H1.5C1.10218 5.03431 0.720644 5.19234 0.43934 5.47365C0.158035 5.75495 0 6.13648 0 6.53431V13.5337C0 13.9315 0.158035 14.313 0.43934 14.5943C0.720644 14.8757 1.10218 15.0337 1.5 15.0337H5.85438L11.5706 19.7212L11.6119 19.7531C11.869 19.9432 12.1802 20.046 12.5 20.0462V20.0449C12.8978 20.0449 13.2794 19.8869 13.5607 19.6056C13.842 19.3243 14 18.9428 14 18.5449V14.8627L4.1716 5.03431ZM14 9.20586V1.52368C14.0002 1.24617 13.9233 0.974047 13.7781 0.737594C13.6328 0.501142 13.4248 0.309626 13.1771 0.184353C12.9295 0.0590793 12.652 0.00495899 12.3754 0.0280122C12.0988 0.0510654 11.8341 0.150388 11.6106 0.314932L11.5694 0.346808L8.03734 3.24319L14 9.20586Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.96582,
    y: 1.41418,
    width: 2,
    height: 26.328,
    rx: 1,
    transform: "rotate(-45 1.96582 1.41418)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerMuted);
export default __webpack_public_path__ + "static/media/speaker-muted.89b41c956827ce46c5924e3bf4abd8e8.svg";
export { ForwardRef as ReactComponent };